import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-full-screen-modal',
  imports: [CommonModule],
  templateUrl: './full-screen-modal.html',
  styleUrl: './full-screen-modal.css',
})
export class FullScreenModal {
  isOpen = input<boolean>(false);
  title = input<string>('');
  closeModal = output<void>();

  close(): void {
    this.closeModal.emit();
  }
}